import * as Yup from 'yup';
import { folderStructure, tryDecodeFilePath } from '@/utils/constants';
import { folderNameSchema } from '@/components/dialogs/AddFolderSharepointDialog/validationSchema';

export const MAX_ADDITIONAL_FOLDERS = 15;
export const ADDITIONAL_FOLDERS_COLLECTION = 'additionalFolders';
export const CLIENT_PIPELINE = 'client';

const CLIENT_DEFAULT_FOLDERS = [
	folderStructure.year,
	folderStructure.clientAttachments,
	folderStructure.clientNotes,
];
const DEAL_DEFAULT_FOLDERS = [folderStructure.notes];

export const ADDITIONAL_FOLDER_TABS = [
	{
		key: process.env.REACT_APP_PIPELINE_PROSPECTS,
		label: 'Prospect',
		defaultFolders: CLIENT_DEFAULT_FOLDERS,
	},
	{
		key: CLIENT_PIPELINE,
		label: 'Client',
		defaultFolders: CLIENT_DEFAULT_FOLDERS,
	},
	{
		key: process.env.REACT_APP_PIPELINE_NEW_BUSINESS,
		label: 'New Business',
		defaultFolders: DEAL_DEFAULT_FOLDERS,
	},
	{
		key: process.env.REACT_APP_PIPELINE_CLAIMS,
		label: 'Claim',
		defaultFolders: DEAL_DEFAULT_FOLDERS,
	},
	{
		key: process.env.REACT_APP_PIPELINE_ENDORSEMENTS,
		label: 'Endorsement',
		defaultFolders: DEAL_DEFAULT_FOLDERS,
	},
	{
		key: process.env.REACT_APP_PIPELINE_RENEWALS,
		label: 'Renewal',
		defaultFolders: DEAL_DEFAULT_FOLDERS,
	},
	{
		key: process.env.REACT_APP_PIPELINE_DEBTORS,
		label: 'Debtor',
		defaultFolders: DEAL_DEFAULT_FOLDERS,
	},
];

export const getClientFolderPipelineId = (isProspect) =>
	isProspect ? process.env.REACT_APP_PIPELINE_PROSPECTS : CLIENT_PIPELINE;

export const folderNamesMatch = (left, right) =>
	tryDecodeFilePath((left ?? '').trim().toLowerCase(), (right ?? '').trim().toLowerCase());

export const getAdditionalFolderInitialValues = (folders = []) =>
	Object.fromEntries(
		ADDITIONAL_FOLDER_TABS.map(({ key }) => {
			const names = [];
			folders
				.filter((folder) => folder.pipelineId === key)
				.forEach((folder) => {
					if (!names.some((name) => folderNamesMatch(name, folder.folderName))) {
						names.push(folder.folderName);
					}
				});
			return [key, names];
		}),
	);

export const additionalFoldersValidationSchema = Yup.object(
	Object.fromEntries(
		ADDITIONAL_FOLDER_TABS.map(({ key, defaultFolders }) => [
			key,
			Yup.array()
				.max(MAX_ADDITIONAL_FOLDERS)
				.of(
					folderNameSchema().test(
						'unique-folder',
						'A folder with this name already exists.',
						function (value) {
							if (!value) return false;
							const siblings = this.parent.filter(
								(_, index) => index !== this.options.index,
							);
							return ![...defaultFolders, ...siblings].some(
								(folder) => folder && folderNamesMatch(folder, value),
							);
						},
					),
				),
		]),
	),
);
